import { createActions, using } from "redux-box";

export default createActions({
  requestAnalyticsStory: using(),
  requestProjectsList: using(),
  requestMagicOtp: using(),
  updateMagicOtp: using("data"),
  requestSchoolMagicOtps: using("school", "offset"),
  requestSchoolMagicOtpGrades: using("school"),
  saveSchoolMagicOtp: using("data"),
  updateSchoolMagicOtp: using("id", "otp"),
  removeSchoolMagicOtp: using("id"),
  setAssignmentContent: using("content"),
  setAssignmentContentType: using("content_type"),
  createBulkAssignment: using("data"),
  setAssignmentCreated : using("data")
});
